import { render, staticRenderFns } from "./agregarDetalle.vue?vue&type=template&id=4d21b064&scoped=true"
import script from "./agregarDetalle.vue?vue&type=script&lang=js"
export * from "./agregarDetalle.vue?vue&type=script&lang=js"
import style0 from "./agregarDetalle.vue?vue&type=style&index=0&id=4d21b064&prod&scoped=true&lang=css"
import style1 from "./agregarDetalle.vue?vue&type=style&index=1&id=4d21b064&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d21b064",
  null
  
)

export default component.exports